import React, { Component } from 'react'
import { Button, Col, Input, Label, Row, Alert } from 'reactstrap'
import Loader from '../Loader'
import { useApolloClient } from '@apollo/client'

import { graphql } from '@apollo/client/react/hoc'
import './NotesHistory.css'
import DatetimeRenderer from '../DatetimeRenderer'
import { DriverNotesDetails, CarNotesDetails } from "./Queries"
import { Query } from '@apollo/client/react/components'
import { UpdateCarNotes, UpdateDriverNotes, UpdateReservation, ChangeReturnMutation, UpdateCustomerLead, UpdateInsuranceMutation, UpdateCarIssueMutation } from "./Mutation"

import withApolloClient from '../../withApolloClient'

class NotesHistoryDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: '',
            input: {
                [this.props.name]: ''
            },
            error: null,
            loading: false,
        }
    }
    componentDidMount() {
        const { apolloClient } = this.props
    }

    updateInput = (e) => {
        const { name, value } = e.target
        this.setState(prevState => ({
            input: {
                ...prevState.input,
                [name]: value,
            },
        }))
    };

    updateNotes = () => {
        this.setState({ loading: true })
        if (this.props.driverId || this.props.carId) {
            let input = this.state.input
            let objectIdKey = null
            let mutationToUse = null
            let resultDataKey = null

            switch (this.props.notesType) {
                case 'CAR':
                case 'GENERAL':
                    if (!['RESERVATION', 'RETURN', 'LEAD', 'INSURANCE', 'DEAL', 'CAR ISSUE'].includes(this.props.notesType)) {
                        objectIdKey = 'id'
                        mutationToUse = UpdateCarNotes
                        resultDataKey = 'updateCar'
                    }
                    break
                case 'RESERVATION':
                    objectIdKey = 'reservationId'
                    mutationToUse = UpdateReservation
                    resultDataKey = 'updateReservation'
                    break
                case 'RETURN':
                    objectIdKey = 'carReturnId'
                    mutationToUse = ChangeReturnMutation
                    resultDataKey = 'changeReturn'
                    break
                case 'LEAD':
                    objectIdKey = 'id'
                    mutationToUse = UpdateCustomerLead
                    resultDataKey = 'updateCustomerLead'
                    break
                case 'INSURANCE':
                    objectIdKey = 'insuranceStatusId'
                    mutationToUse = UpdateInsuranceMutation
                    resultDataKey = 'updateInsuranceStatus'
                    break
                case 'CAR ISSUE':
                    objectIdKey = 'issueId'
                    mutationToUse = UpdateCarIssueMutation
                    resultDataKey = 'updateCarIssue'
                    break
                default:
                    objectIdKey = 'id'
                    mutationToUse = UpdateDriverNotes
                    resultDataKey = 'updateDriver'
                    break
            }

            if (objectIdKey) {
                input[objectIdKey] = this.props.objectId || this.props.carId || this.props.driverId
            }

            this.props.apolloClient.mutate({
                mutation: mutationToUse,
                variables: { input },
            }).then((result) => {
                if (result && result.data && result.data[resultDataKey] && result.data[resultDataKey].ok) {
                    this.props.refetchQuery()
                    this.setState({ input: {}, loading: false, error: null })
                } else {
                    let error = 'An error occurred, could not complete request.'
                    if (result && result.data && result.data[resultDataKey] && result.data[resultDataKey].errors[0] && result.data[resultDataKey].errors[0].messages) {
                        error = result.data[resultDataKey].errors[0].messages.toString()
                    }
                    this.setState({ error })
                }
                this.setState({ loading: false })
            }).catch((err) => {
                this.setState({ loading: false, error: 'An error has occurred. Please contact admin: ' + err })
            })
        } else {
            this.setState({ loading: false, error: 'Missing Required Field' })
        }
    };


    render() {
        const { notesId, objectType, loading, recentNotesId } = this.props
        const query = objectType === 'carNotes' ? CarNotesDetails : DriverNotesDetails
        return (
            <>
                {this.props.loading || this.state.loading ? <Loader /> :
                    <div className="notes-history-details">
                        {notesId && notesId !== null ?
                            <Query query={query} variables={{ notesId }} fetchPolicy="cache-and-network" notifyOnNetworkStatusChange={true} >
                                {({ loading: queryLoading, data, error }) => {
                                    if (queryLoading || loading) return <Loader />
                                    const notesDetails = data ? data[`${objectType}Details`] : null
                                    if (notesDetails && this.state.input[this.props.name] === '' && notesDetails.changedTo !== this.state.input[this.props.name]) {
                                        this.setState({
                                            input: { [this.props.name]: notesDetails.changedTo }
                                        })
                                    }
                                    return notesDetails && (
                                        <div className="notes-history-details-container">
                                            {(error || this.state.error) && <Alert color="danger">{this.state.error ? this.state.error : error}</Alert>}
                                            <Row>
                                                <Col>
                                                    <Label>Date Added</Label>
                                                    <p><DatetimeRenderer datetime={notesDetails.dateAdded || '0000-00-00'} /></p>
                                                </Col>
                                                <Col>
                                                    <Label>Username</Label>
                                                    <p>{notesDetails.user ? notesDetails.user.firstName ? notesDetails.user.firstName + " " + notesDetails.user.lastName : notesDetails.user.username : '--'}</p>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>{recentNotesId === notesDetails.id ? 'Previous' : 'Changed From'}</Label>
                                                    <p>{notesDetails.changedFrom || '--'}</p>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>{recentNotesId === notesDetails.id ? 'Current' : 'Changed To'}</Label>
                                                    {recentNotesId === notesDetails.id ?
                                                        <Input
                                                            type="textarea"
                                                            rows="5"
                                                            style={{
                                                                resize: 'vertical !important', // User can resize vertically
                                                                minHeight: '4.5em'  // Optional: enforce height matching `rows`
                                                            }}
                                                            disabled={recentNotesId !== notesDetails.id}
                                                            name={this.props.name}
                                                            id={this.props.name}
                                                            defaultValue={notesDetails.changedTo}
                                                            placeholder="Edit Notes"
                                                            onChange={this.updateInput}
                                                        /> :
                                                        <><br /><p>{notesDetails.changedTo || '--'}</p></>
                                                    }
                                                </Col>
                                            </Row>
                                            {recentNotesId === notesDetails.id &&
                                                <Row><Col className="text-right pt-3">
                                                    <Button
                                                        size="sm"
                                                        className="primary"
                                                        onClick={this.updateNotes}
                                                        disabled={this.state.input[this.props.name] === notesDetails.changedTo}
                                                    >Update</Button>
                                                </Col></Row>
                                            }
                                        </div>
                                    )
                                }}
                            </Query> :
                            <div className="notes-history-details-container pt-2">
                                {(this.state.error) && <Alert color="danger">{this.state.error ? this.state.error : "--"}</Alert>}
                                <Row>
                                    <Col>
                                        <Label>Add New Notes</Label>
                                        <Input
                                            type="textarea"
                                            name={this.props.name}
                                            id={this.props.name}
                                            placeholder="Edit Notes"
                                            onChange={this.updateInput}
                                        />
                                    </Col>
                                </Row>
                                <Row><Col className="text-right pt-3">
                                    <Button
                                        size="sm"
                                        className="primary"
                                        onClick={this.updateNotes}
                                    >Add Notes</Button>
                                </Col></Row>
                            </div>
                        }
                    </div>
                }
            </>
        )
    }
}


export default withApolloClient(NotesHistoryDetail)
